import { dollars } from "../../../utils";

const calculateYearlySavings = (
  amount: string,
  frequency: API.SubscriptionFrequency,
): number => {
  const parsedAmount = parseFloat(amount);

  switch (frequency) {
    case "daily":
      return parsedAmount * 365;
    case "semi-monthly":
      return parsedAmount * 24;
    case "monthly":
      return parsedAmount * 12;
    case "bimonthly":
      return parsedAmount * 6;
    case "quarterly":
      return parsedAmount * 4;
    case "biannually":
      return parsedAmount * 2;
    case "annually":
      return parsedAmount;
    default:
      return 0;
  }
};

const calculateEstimatedYearlySavings = (
  amount: string,
  frequency: API.SubscriptionFrequency,
): Dollars => dollars(Math.round(calculateYearlySavings(amount, frequency)));

export { calculateEstimatedYearlySavings };
